module.exports = __webpack_public_path__ + "img/before.e39500fa.svg";